export const colorIntegerToHex = ( int:number ) =>
(
  (int||0).toString(16).padStart(6,'0')
)

export const colorIntegerToHashTag = ( int:number ) =>
(
  '#' + colorIntegerToHex( int )
)
